import { Form } from 'connex-cds';
import React from 'react';
import styled from 'styled-components';
import cn from 'classnames';
import style from './style';
import { View } from './View';
import config from '../config';

const Styled = styled.div`
  ${style}
`;

const initialValues = {
  lastName: '',
  firstName: '',
  email: '',
  phoneNumber: '',
};

export const InviteUser = props => {
  return (
    <Styled className={cn('invite-user')}>
      <Form.FormProvider config={config} initialValues={initialValues}>
        <View />
      </Form.FormProvider>
    </Styled>
  );
};
